import { c as _c } from "react/compiler-runtime";
import { Badge } from "@repo/ui/components/ui/badge";
import { Button } from "@repo/ui/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@repo/ui/components/ui/tabs";
import { List, MapIcon } from "lucide-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ReviewQueueTabs(t0) {
  const $ = _c(34);
  const {
    tab,
    onTabChange,
    view,
    onViewChange,
    counts
  } = t0;
  let t1;
  if ($[0] !== onTabChange) {
    t1 = v => onTabChange(v);
    $[0] = onTabChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== counts.places) {
    t2 = /*#__PURE__*/_jsxs(TabsTrigger, {
      value: "places",
      className: "gap-2",
      children: ["Platser", /*#__PURE__*/_jsx(Badge, {
        variant: "secondary",
        className: "px-1.5",
        children: counts.places
      })]
    });
    $[2] = counts.places;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== counts.features) {
    t3 = /*#__PURE__*/_jsxs(TabsTrigger, {
      value: "features",
      className: "gap-2",
      children: ["Funktioner", /*#__PURE__*/_jsx(Badge, {
        variant: "secondary",
        className: "px-1.5",
        children: counts.features
      })]
    });
    $[4] = counts.features;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== counts.all) {
    t4 = /*#__PURE__*/_jsxs(TabsTrigger, {
      value: "all",
      className: "gap-2",
      children: ["Allt", /*#__PURE__*/_jsx(Badge, {
        variant: "secondary",
        className: "px-1.5",
        children: counts.all
      })]
    });
    $[6] = counts.all;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = /*#__PURE__*/_jsxs(TabsList, {
      children: [t2, t3, t4]
    });
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5 || $[14] !== tab) {
    t6 = /*#__PURE__*/_jsx(Tabs, {
      value: tab,
      onValueChange: t1,
      children: t5
    });
    $[12] = t1;
    $[13] = t5;
    $[14] = tab;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = view === "list" ? "secondary" : "ghost";
  let t8;
  if ($[16] !== onViewChange) {
    t8 = () => onViewChange("list");
    $[16] = onViewChange;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = /*#__PURE__*/_jsx(List, {
      className: "h-3.5 w-3.5"
    });
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t8) {
    t10 = /*#__PURE__*/_jsxs(Button, {
      size: "sm",
      variant: t7,
      className: "h-7 gap-1.5 px-2",
      onClick: t8,
      children: [t9, "Lista"]
    });
    $[19] = t7;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = view === "map" ? "secondary" : "ghost";
  let t12;
  if ($[22] !== onViewChange) {
    t12 = () => onViewChange("map");
    $[22] = onViewChange;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = /*#__PURE__*/_jsx(MapIcon, {
      className: "h-3.5 w-3.5"
    });
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t12) {
    t14 = /*#__PURE__*/_jsxs(Button, {
      size: "sm",
      variant: t11,
      className: "h-7 gap-1.5 px-2",
      onClick: t12,
      children: [t13, "Karta"]
    });
    $[25] = t11;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14) {
    t15 = /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-1 rounded-md border p-0.5",
      children: [t10, t14]
    });
    $[28] = t10;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15 || $[32] !== t6) {
    t16 = /*#__PURE__*/_jsxs("div", {
      className: "flex flex-wrap items-center justify-between gap-3 border-b px-4 py-3",
      children: [t6, t15]
    });
    $[31] = t15;
    $[32] = t6;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
}